<template>
  <sea-page-content toolbar hideRapidSearch in-tab>
    <v-card flat tile>
      <v-card-title class="justify-center">
        <div class="text-center title text-h6">
          Dettaglio anno {{ cud.anno }}
        </div>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="3" offset="3">
            <v-card outlined flat tile>
              <div class="text-center head">Reddito lordo</div>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card outlined flat tile>
              <div class="text-center head">Giorni detrazione</div>
            </v-card>
          </v-col>
          <v-col cols="3" offset="3">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ cud.redditoLordo | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="3">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ cud.giorniDetrazione }}
              </div></v-card
            >
          </v-col>
          <v-col cols="3" offset="3">
            <v-card outlined flat tile
              ><div class="text-center head">Addizionali Irpef</div></v-card
            >
          </v-col>
          <v-col cols="3">
            <v-card outlined flat tile
              ><div class="text-center head">Ritenute Irpef</div></v-card
            >
          </v-col>
          <v-col cols="3" offset="3">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ cud.addizionaliIrpef | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="3">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ cud.ritenuteIrpef | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="6" offset="3">
            <v-card outlined flat tile
              ><div class="text-center head">Addizionale comunale</div></v-card
            >
          </v-col>
          <v-col cols="2" offset="3">
            <v-card outlined flat tile
              ><div class="text-center head">
                Acconto {{ cud.anno - 1 }}
              </div></v-card
            >
          </v-col>
          <v-col cols="2">
            <v-card outlined flat tile
              ><div class="text-center head">
                Saldo {{ cud.anno - 1 }}
              </div></v-card
            >
          </v-col>
          <v-col cols="2">
            <v-card outlined flat tile
              ><div class="text-center head">
                Acconto {{ cud.anno }}
              </div></v-card
            >
          </v-col>
          <v-col cols="2" offset="3">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ cud.accontoAnnoPrecedente | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="2">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ cud.saldoAnnoPrecedente | currencyFormat }}
              </div></v-card
            >
          </v-col>
          <v-col cols="2">
            <v-card outlined flat tile
              ><div class="text-center">
                {{ cud.accontoAnnoCorrente | currencyFormat }}
              </div></v-card
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </sea-page-content>
</template>

<script>
import mixin from "@/mixin";

export default {
  mixins: [mixin],
  props: ["cud"],
};
</script>

<style></style>
